@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Vendors"
  [gridData]="$gridData()"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/vendor', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="tin" title="TIN" />
  <kendo-grid-column field="type.name" title="Vendor Type" />
  <kendo-grid-column field="current_state.name" title="Status" [width]="200">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
